import { Box, Chip, CircularProgress, OutlinedInput, Select, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import MUISelect from "../../Component/UI/MUISelect/MUISelect";
import MUIIconButton from "../../Component/UI/MUIIconButton/MUIIconButton";
import selectClasses from "../../Component/UI/MUISelect/MUISelect.module.css";
import classes from "../BrandAudit/Form.module.css";

function ReadOnlyLLMList({ options }) {
  return (
    <Box className={selectClasses.box}>
      <Typography className={selectClasses.label}>&nbsp;</Typography>
      <Select
        multiple
        value={options.map((o) => o.value)}
        open={false}
        readOnly
        input={<OutlinedInput notched sx={{ borderRadius: "4px", backgroundColor: "#f8fafc" }} />}
        renderValue={(selected) => (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, py: "2px" }}>
            {selected.map((val) => (
              <Chip key={val} size="small" label={options.find((o) => o.value === val)?.name} />
            ))}
          </Box>
        )}
        fullWidth
        size="small"
        sx={{ "& .MuiSelect-select": { padding: "6px 10px" }, pointerEvents: "none" }}
      />
    </Box>
  );
}

export default function CMForm({
  category,
  llmMode,
  singleLlm,
  market,
  categoryOptions,
  llmOptions,
  marketOptions,
  onCategoryChange,
  onLLMModeChange,
  onSingleLLMChange,
  onMarketChange,
  onRefresh,
  loading,
  optionsLoading,
}) {
  const isSingleMode = llmMode === "single";

  return (
    <div className={classes.card}>
      <div className={classes.header}>
        <div className={classes.radio} style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <Typography variant="subtitle1" fontWeight={600}>Category Monitoring</Typography>
          {optionsLoading && <CircularProgress size={16} thickness={5} />}
        </div>
      </div>

      <div className={classes.input_group}>
        <div className={classes.input_section}>
          <div style={{ flex: 1 }}>
            <MUISelect
              label="Category"
              options={categoryOptions}
              optionValue={category}
              disabled={loading || categoryOptions.length === 0}
              onChange={(e) => onCategoryChange(e.target.value)}
            />
          </div>
          <div style={{ flex: 2, display: "flex", gap: 8 }}>
            <Box sx={{ minWidth: 130 }}>
              <Typography sx={{ fontSize: "11px !important", color: "rgba(0,0,0,0.6) !important", pb: "5px" }}>
                LLM
              </Typography>
              <ToggleButtonGroup
                exclusive
                size="small"
                value={llmMode}
                onChange={(e, val) => val && onLLMModeChange(val)}
                disabled={loading || llmOptions.length === 0}
                sx={{ height: "31px" }}
              >
                <ToggleButton value="single" sx={{ fontSize: 12, textTransform: "none", padding: "4px 12px" }}>
                  Single
                </ToggleButton>
                <ToggleButton value="all" sx={{ fontSize: 12, textTransform: "none", padding: "4px 12px" }}>
                  All
                </ToggleButton>
              </ToggleButtonGroup>
            </Box>
            <div style={{ flex: 1 }}>
              {isSingleMode ? (
                <MUISelect
                  label="&nbsp;"
                  options={llmOptions}
                  optionValue={singleLlm}
                  disabled={loading || llmOptions.length === 0}
                  onChange={(e) => onSingleLLMChange(e.target.value)}
                />
              ) : (
                <ReadOnlyLLMList options={llmOptions} />
              )}
            </div>
          </div>
          <div style={{ flex: 1, display: "flex", alignItems: "flex-end", gap: 4 }}>
            <div style={{ flex: 1 }}>
              <MUISelect
                label="Market"
                options={marketOptions}
                optionValue={market}
                disabled={loading || marketOptions.length === 0}
                onChange={(e) => onMarketChange(e.target.value)}
              />
            </div>
            <MUIIconButton
              tooltip="Refresh data for the selected options"
              onClick={onRefresh}
              disabled={loading || !category || (isSingleMode && !singleLlm) || !market}
              sx={{ mb: "2px" }}
            >
              <RefreshIcon fontSize="small" />
            </MUIIconButton>
          </div>
        </div>
      </div>
    </div>
  );
}
